<template>
	<div>
		<template v-for="(prop, index) in offersChooser">
			<div class="b-detail__packing">
				<div class="b-packing__title b-detail__label" v-html="prop.name"></div>
				<div class="b-form b-form_packing b-packing__select">
					<form-field-select
						:field-props="selectFields[index]"
						:value="selectFields[index].VALUE"
						v-model="selectFields[index].VALUE"
						@input="onSelectOffer($event, prop.id, index)"
					></form-field-select>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "CitrusProductOffersChooserSelect",
	data() {
		return {
			selectFields: [],
		}
	},
	created() {
		this.propMatrix = this.offer.prop_matrix;

		this.prepareSelectFields();
	},
	computed: {
		sadasd() {
			return this.offer.hasOwnProperty('prop_matrix')
				&& this.offer.prop_matrix.hasOwnProperty('PROP_' + propertyId)
				&& this.offer.prop_matrix['PROP_' + propertyId] === optionId;
		}
	},
	methods: {
		/**
		 * Обработка выбора торгового предложения
		 */
		onSelectOffer(optionId, propertyId, index) {
			this.chooseOffers(optionId, propertyId, index);
		},
		prepareSelectFields() {
			this.selectFields = [];
			for (let prop of this.offersChooser) {
				let values = [];
				for (let option of prop.options) {
					values.push({
						"ID": option.id,
						"VALUE": option.name,
						"label": option.name
					});
				}

				let selectedOptionId = this.offer.hasOwnProperty('prop_matrix') && this.offer.prop_matrix.hasOwnProperty('PROP_' + prop.id)
					? this.offer.prop_matrix['PROP_' + prop.id]
					: "";

				this.selectFields.push({
					"TITLE": prop.name,
					"PLACEHOLDER": "",
					"CODE": prop.code,
					"TYPE": "select",
					"VALUE": selectedOptionId,
					"VALUES": values,
					withLabel: false
				});
			}
		}
	}
}
</script>